var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19434 12.3802C1.19434 12.6582 1.41967 12.8835 1.69763 12.8835H13.5681L10.401 16.0506C10.2044 16.2472 10.2044 16.5658 10.401 16.7624C10.5975 16.9589 10.9162 16.9589 11.1127 16.7624L15.139 12.7361C15.3356 12.5395 15.3356 12.2209 15.139 12.0243L11.1127 7.998C10.9162 7.80145 10.5975 7.80145 10.401 7.998C10.2044 8.19454 10.2044 8.51321 10.401 8.70976L13.5681 11.8769H1.69763C1.41967 11.8769 1.19434 12.1022 1.19434 12.3802Z",
    fill: "#16A34A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2861 5.33429C15.2861 5.61225 15.0608 5.83758 14.7828 5.83758L2.91236 5.83758L6.07951 9.00473C6.27606 9.20128 6.27606 9.51994 6.07951 9.71649C5.88297 9.91304 5.5643 9.91304 5.36775 9.71649L1.34144 5.69017C1.14489 5.49363 1.14489 5.17496 1.34144 4.97841L5.36775 0.952098C5.5643 0.755551 5.88297 0.755551 6.07951 0.952098C6.27606 1.14864 6.27606 1.46731 6.07951 1.66386L2.91236 4.831L14.7828 4.831C15.0608 4.831 15.2861 5.05633 15.2861 5.33429Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRight);
export default __webpack_public_path__ + "static/media/arrow-left-right.16562171ef55fcd16bd87b746181204d.svg";
export { ForwardRef as ReactComponent };